import { createContext, useContext } from 'react'

export type ModalState = {
  open: boolean
  selectedIds?: string[]
  onSuccess?: (value?: any) => void
}

export interface UserSupplyShedManagementState {
  setDeleteModal(state: ModalState): void
  setShareModal(state: ModalState): void

  confirmDeleteUserSupplyShed(resourceId: string): Promise<any>
}

export const UserSupplyShedManagementContext = createContext<UserSupplyShedManagementState>({
  setDeleteModal: console.log,
  setShareModal: console.log,

  confirmDeleteUserSupplyShed: (resourceId: string) => new Promise(resolve => {}),
})
UserSupplyShedManagementContext.displayName = 'UserSupplyShedManagementContext'

export const useUserSupplyShedManagement = () => useContext(UserSupplyShedManagementContext)
